// The Vue build version to load with the 'import' command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import {polyfill} from 'es6-promise';
import 'babel-polyfill'
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import iView from 'iview';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import locale from 'iview/dist/locale/en-US';
import {isAuthenticated} from "./services/Authentication.service";
import VueHtml2Canvas from 'vue-html2canvas';
import 'iview/dist/styles/iview.css';

polyfill();

export const bus = new Vue();
require('../node_modules/xlsx');

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'XCSRF-TOKEN';
Vue.use(VueAxios, axios);
Vue.use(iView, {locale});
Vue.use(VueMoment, {moment});
Vue.use(VueHtml2Canvas);
Vue.config.productionTip = false;
Vue.config.devtools = false;
require('./assets/css/styles.css');
require('./assets/css/bootstrap.key4.css');

/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  let path = to.path.toLowerCase();
  if (path.indexOf('signin') > -1) {
    let queries = JSON.stringify(to.query);
    localStorage.setItem('API_Query', queries);
    router.push({name: 'Login'});

  } else {
    if (to.meta.requiredAuth) {
      if (isAuthenticated()) {
        if (localStorage.getItem('role').toLowerCase() !== 'admin' &&
          (to.path.indexOf('my-lead-forms') > -1 || to.path.indexOf('global') > -1)) {
          router.push({name: 'GeneralDashboard'});
        } else {
          next();
        }
      } else {
        next({name: 'Authentication'});
      }
    } else {
      next();
    }
  }
});

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js